export const postActivityLogsKeys = {
  all: ['post-activity-logs'] as const,
  list: (postId: string) => [...postActivityLogsKeys.all, 'list', postId] as const,
};
